//######################### Parent Order #########################
export const ConfigKey_FindingView_ParentOrder = 'finding-view__parent-order';
export const ConfigKey_FindingView_Cockpit = 'finding-view__cockpit';
//######################### Independent Scores #########################
export const ConfigKey_IndependentScores = 'independent-scores';
export const ConfigKey_AdvisorHomePanel = 'advisor-home-panel';
//# sourceMappingURL=app-configs.js.map